import { Button, Space } from "antd";
import { history } from "@umijs/max";
import React from "react";

export interface FormFooterProps {
  /**
   * 页面类型：1-新建, 2-编辑, 3-查看
   */
  pageType?: number;
  /**
   * 提交按钮文本
   */
  submitText?: string;
  /**
   * 取消按钮文本
   */
  cancelText?: string;
  /**
   * 重置按钮文本
   */
  resetText?: string;
  /**
   * 提交按钮加载状态
   */
  loading?: boolean;
  /**
   * 提交事件
   */
  onSubmit?: () => void;
  /**
   * 取消事件（默认返回上一页）
   */
  onCancel?: () => void;
  /**
   * 重置事件
   */
  onReset?: () => void;
  /**
   * 是否显示取消按钮
   */
  showCancel?: boolean;
  /**
   * 是否显示重置按钮
   */
  showReset?: boolean;
  /**
   * 是否显示提交按钮
   */
  showSubmit?: boolean;
  /**
   * 自定义类名
   */
  className?: string;
  /**
   * 左侧自定义内容
   */
  leftCotent?: React.ReactNode;
}

const FormFooter: React.FC<FormFooterProps> = ({
  pageType = 1,
  submitText,
  cancelText = "",
  resetText = "重置",
  loading = false,
  onSubmit,
  onCancel,
  onReset,
  showCancel = true,
  showReset = true,
  showSubmit = true,
  className = "",
  leftCotent = <span>&nbsp;</span>,
}) => {
  const isSubmittingRef = React.useRef(false);

  // 默认取消处理
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      history.back();
    }
  };

  // 默认提交按钮文本
  const getSubmitText = () => {
    if (submitText) return submitText;
    if (pageType === 2) return "保存";
    if (pageType === 3) return "确定";
    return "提交";
  };
   // 默认提交按钮文本
  const getCannelText = () => { 
    if (cancelText) return cancelText;
    if (pageType == 1) return "取消";
    if (pageType == 2) return "取消";
    if (pageType == 3) return "返回";
    return '取消'
  };
  // 判断是否显示重置按钮（仅在新建页面显示）
  const shouldShowReset = showReset && pageType === 1;

  // 判断是否显示取消按钮（非新建页面显示）
  const shouldShowCancel = showCancel && pageType !== 1;
  //显示确认
  const shouldShowSubmit = showSubmit && pageType !== 3;

  const handleSubmit = () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    try {
      onSubmit?.();
    } finally {
      isSubmittingRef.current = false;
    }
  };
  return (
    <div className={`page-form-footer ${className}`}>
      <Space>
        <>{leftCotent}</>
      </Space>
      <Space>
         {pageType === 1 && (
          <Button className="btn-2" onClick={handleCancel} disabled={loading}>
            取消
          </Button>
        )}
        {shouldShowReset && onReset && (
          <Button className="btn-2" onClick={onReset}>
            {resetText}
          </Button>
        )}
        {shouldShowCancel && (
          <Button className="btn-2" onClick={handleCancel} disabled={loading}>
            {getCannelText()}
          </Button>
        )}
        {shouldShowSubmit && onSubmit && (
          <Button type="primary" disabled={loading} onClick={handleSubmit} loading={loading}>
            {getSubmitText()}
          </Button>
        )}
      </Space>
    </div>
  );
};

export default FormFooter;
